import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import template from './Add.vue';
import Button from '@/components/Button';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import BackButton from '@/components/BackButton';
import { AddressForm } from '@/store/models/address';
import store from '@/store';
import auth from '@/store/modules/auth';
import address from '@/store/modules/address';
import { router } from '@/_helpers/router';
import { validation } from '@/_helpers/validation';
import countries from '@/_helpers/countries';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		Button,
		MDTextFieldWithValidation,
		BackButton
	}
})
export default class PaymentAdd extends Vue {
	loading: boolean = false;

	countries: {}[] = [];

	form: AddressForm = {
		customerId: '',
		street: '',
		city: '',
		zipCode: '',
		country: '',
		isDelivery: true,
		isInvoice: true
	};

	async mounted(): Promise<void> {
		this.countries = countries;
		try {
			auth.getSelf(false);
		} catch (error) {
			store.commit('openNotifier', { text: `Er ging wat mis tijdens het laden`, color: 'error' });
		}
	}

	async add(): Promise<void> {
		const isValid = await (this.$refs.form as any).validate();
		if (!isValid) {
			return;
		}
		this.loading = true;
		this.form.customerId = auth.self.customerId;
		try {
			await address.create(this.form);
			router.push({ name: 'addressbook' });
		} catch (error) {
			(this.$refs.form as any).setErrors(validation.getErrors(error.data.errors));
		}
	}
}
